import React, { useEffect, useState } from 'react';
import style from './select.module.css';
import img1 from './res/img1.jpg';
import img2 from './res/img2.jpg';

const Select = (props) => {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    setIsTouch(hasTouch);
    // 清理
    return () => {
      document.body.classList.remove('touch-device');
    };
  }, []);

  const imgList = [[img1,'兒童行爲測試'],[img2,'情緒測試']]

  const clickImg = (index) => {
    props.selectIndex(index+1)
  };
  

  return (
    <div>
        <div className={style.selectImgs} style={{zIndex: 2000}}>
          {imgList.map((_, index) => (
            <div
              className={style.imageContainer}
              key={`container-${index}`}
              style={isTouch ? { opacity: 0.9 } : {}}
            >
              <img
                key={index}
                src={imgList[index][0]}
                alt={`img ${index}`}
                {...(isTouch
                  ? { onTouchStart: () => clickImg(index) }
                  : { onClick: () => clickImg(index) })}
              />
              <h1>{imgList[index][1]}</h1>
            </div>
            
          ))}
      </div>
      {
          <button className={'bt small green'}
            style={{
              bottom: '1%',
              left: '50%',
              width: '10%',
              transform: 'translate(-50%,0)',
              position: 'absolute',
              zIndex: 2001,
            }}
            onClick={() => {
              // Add your logout logic here
              sessionStorage.removeItem('uid');
              window.location.href = '/';
              console.log('Logout clicked');
            }}>退出</button>
      }
    </div>
  );
};

export default Select;
